"use client";

import React, { useState } from "react";
import styles from "./EmailHeader.module.scss";
import { EMAIL } from "@/utils/constants";

const EmailHeader: React.FC = () => {
	const [showCopied, setShowCopied] = useState(false);

	const handleCopyEmail = async () => {
		try {
			await navigator.clipboard.writeText(EMAIL);
			setShowCopied(true);
			setTimeout(() => setShowCopied(false), 2000);
		} catch (err) {
			console.error("Failed to copy:", err);
		}
	};

	return (
		<div className={styles.emailHeader}>
			<div className={styles.emailHeader__content}>
				<div className={styles.emailHeader__leftSection}>
					<h1 className={styles.emailHeader__emailText} aria-label="Email Address: hi@parallellab.co" onClick={handleCopyEmail}>
						HI@
						<br />
						PARALLELLAB
						<br />
						<div className={styles["emailHeader__copy-container"]}>
							<button className={styles.emailHeader__clickToCopy} onClick={handleCopyEmail}>
								{showCopied ? "Email copied to clipboard!" : "Click email to Copy"}
							</button>
							<span>.CO</span>
						</div>
					</h1>
				</div>

				<div className={styles.stamp}>
					<img src="/images/email-stamp.svg" alt="" width={362} height={250} />
				</div>
			</div>
		</div>
	);
};

export default EmailHeader;
